import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { requireMenuOrRedirect } from '@/lib/auth/require-permission';

const ProvidersPage = lazy(() =>
  import('@/pages/ads/ad-providers/providers-page').then((m) => ({ default: m.ProvidersPage })),
);

export const Route = createFileRoute('/_app/ads/ad-providers')({
  beforeLoad: requireMenuOrRedirect('menu:ads-admin:ad-providers', '/ads/accounts'),
  component: () => (
    <Suspense fallback={<div>加载中…</div>}>
      <ProvidersPage />
    </Suspense>
  ),
});
